import { useQuery } from '@tanstack/vue-query';
import { queries } from './index.js';

export function useWorkspace() {
  return useQuery(queries.workspace.current);
}

export function useExternalUsers(hash) {
  return useQuery(queries.project.externalUsers(hash));
}

export function useProjectPendingInvitations(hash) {
  return useQuery(queries.project.pendingInvitations(hash));
}
